export default {
  data() {
    return{
      toUrl: ''
    }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL); //这里有没有都无所谓，最好是有以防万一
      window.addEventListener("popstate", this.goBack, false); // 回退时执行goback方法
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods:{
    goBack() {
      this.$router.go(-1); //根据其需求，回退到指定地址
      this.$store.commit('common/backNavList',{url: this.toUrl});
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name&&!vm.$store.state.common.isBack) {
        vm.$store.commit('common/pushNavList', {
          url: from.fullPath,
          name: from.meta.title,
        });
        // vm.$addStorageEvent(2, "preMenu", JSON.stringify({
        //   url: from.fullPath,
        //   name: from.meta.title
        // }));
      }
      vm.$store.commit('common/updateIsBack'); 
    })
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    // this.$addStorageEvent(2, "preMenu", null);
    // this.$store.commit('common/backNavList',{url: to.fullPath});
    this.toUrl = to.fullPath;
    if(Object.keys(to.query).length===0) this.$store.commit('common/emptyNavList');
    next(true);
  },
}